import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface IProps {
  open: boolean;
  hideDialog: () => void;
  toast: any;
  historyId?: number;
}

interface IEmailHistoryDetail {
  name?: string;
  email?: string;
  vendor_Company?: string;
  email_Status?: number;
  email_Sent_Time?: string;
}

export const EmailList = ({
  open,
  hideDialog,
  toast,
  historyId
}: IProps) => {

  const [data, setData] = useState<IEmailHistoryDetail[]>([]);
  const [loading, setLoading] = useState(false);

  
  const loadData = async () => {
    if (!historyId) return;

    setLoading(true);

    const response = await Fetch(
      `MassMail/getEmailsByHistoryId`,
      "GET",
      null,
      `historyId=${historyId}`,
      toast
    );

    if (response) {
      const res = await response.json();
       setData(res.emails || []);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (open) loadData();
  }, [open, historyId]);

 
  const emailStatusTemplate = (row: IEmailHistoryDetail) => {
  if (row.email_Status === 1) {
    return (
      <p
        style={{
          color: "black",
          backgroundColor: "#fcf951",
          padding: "5px 10px",
          borderRadius: "20px",
          fontWeight: 600,
          display: "inline-block",
         
        }}
      >
        Pending
      </p>
    );
  }

  if (row.email_Status === 2) {
    return (
      <p
        style={{
          color: "white",
          backgroundColor: "#155724",
          padding: "5px 10px",
          borderRadius: "20px",
          fontWeight: 600,
          display: "inline-block"
        }}
      >
        Sent
      </p>
    );
  }

  if (row.email_Status === 3) {
    return (
      <p
        style={{
          color: "white",
          backgroundColor: "#721c24",
          padding: "5px 10px",
          borderRadius: "20px",
          fontWeight: 600,
          display: "inline-block"
        }}
      >
        Failed
      </p>
    );
  }

  return "-";
};


 
  const dateTemplate = (row: IEmailHistoryDetail) => {
    if (!row.email_Sent_Time) return "-";
     return new Date(row.email_Sent_Time).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  });
  };

  return (
    <Dialog
      visible={open}
      style={{ width: "75vw" }}
      header="Email Details"
      onHide={hideDialog}
      modal
    >

      <DataTable
        value={data}
        loading={loading}
        size="small"
        stripedRows
        showGridlines
        emptyMessage="No Emails Found"
      >

        <Column header="SN" body={(rowData, options) => options.rowIndex + 1} style={{ width: "60px" }} />
        <Column field="name" header="Name"  />
        <Column field="email" header="Email"  />
        <Column field="vendor_Company" header="Vendor Company"  />
        <Column  header="Email Status" body={emailStatusTemplate} />
        <Column header="Sent Time" body={dateTemplate} />

      </DataTable>

    </Dialog>
  );
};
